import { clearSessionDeadline, SEAT_TOKEN_KEYS, validSessionToken } from './sessionTimeout.ts';

export const OPERATOR_KEY = 'aiscoreboard.operatorToken';
export const OPERATOR_EVENT = 'aiscoreboard-operator-changed';

export function operatorToken(): string | null {
  return validSessionToken(OPERATOR_KEY);
}

export function controlToken(): string | null {
  if (typeof window === 'undefined') return null;
  return validSessionToken(SEAT_TOKEN_KEYS[0]) ?? validSessionToken(SEAT_TOKEN_KEYS[1]);
}

export function saveOperatorToken(token: string | null): void {
  if (token) window.localStorage.setItem(OPERATOR_KEY, token);
  else window.localStorage.removeItem(OPERATOR_KEY);
  clearSessionDeadline(OPERATOR_KEY);
  window.dispatchEvent(new Event(OPERATOR_EVENT));
}
